import React from 'react';
import { ChevronRightIcon } from 'lucide-react';
export function PricingSection() {
  const mainServices = [{
    name: 'Pintura completa',
    price: 'Desde 1.200 €'
  }, {
    name: 'Pulido de pintura',
    price: 'Desde 150 €'
  }, {
    name: 'Pintado integral',
    price: 'Desde 1.500 €'
  }, {
    name: 'Pintado integral + golpes',
    price: 'Desde 1.800 €'
  }, {
    name: 'Pintado integral sin techo',
    price: 'Desde 1.300 €'
  }, {
    name: 'Cambio de color completo',
    price: 'Desde 2.500 €'
  }];
  const pieceServices = [{
    name: 'Puerta trasera',
    price: 'Desde 200 €'
  }, {
    name: 'Paragolpes delantero',
    price: 'Desde 180 €'
  }, {
    name: 'Paragolpes trasero',
    price: 'Desde 180 €'
  }, {
    name: 'Aleta delantera',
    price: 'Desde 150 €'
  }, {
    name: 'Costado trasero',
    price: 'Desde 250 €'
  }, {
    name: 'Capó',
    price: 'Desde 200 €'
  }, {
    name: 'Techo',
    price: 'Desde 250 €'
  }, {
    name: 'Retrovisor',
    price: 'Desde 80 €'
  }, {
    name: 'Rejilla',
    price: 'Desde 100 €'
  }];
  return <section id="tarifas" className="bg-gradient-to-b from-white to-gray-50 py-24" data-id="element-180">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-181">
        <div className="text-center mb-16" data-id="element-182">
          <h2 className="text-3xl font-bold text-gray-900 sm:text-4xl" data-id="element-183">
            Nuestras Tarifas
          </h2>
          <div className="mx-auto mt-4 h-1 w-20 bg-red-600 rounded-full" data-id="element-184"></div>
          <p className="mt-4 text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-185">
            Transparencia y calidad. Precios competitivos para acabados premium.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-186">
          {/* Main Services Table */}
          <div className="bg-white rounded-2xl shadow-xl border border-gray-100 overflow-hidden" data-id="element-187">
            <div className="bg-gray-900 px-6 py-4" data-id="element-188">
              <h3 className="text-xl font-bold text-white" data-id="element-189">
                Servicios Integrales
              </h3>
            </div>
            <div className="divide-y divide-gray-100" data-id="element-190">
              {mainServices.map((item, index) => <div key={index} className="flex items-center justify-between px-6 py-4 hover:bg-gray-50 transition-colors" data-id="element-191">
                  <div className="flex items-center" data-id="element-192">
                    <ChevronRightIcon className="h-4 w-4 text-red-500 mr-2" data-id="element-193" />
                    <span className="text-gray-800 font-medium" data-id="element-194">
                      {item.name}
                    </span>
                  </div>
                  <span className="text-gray-900 font-bold bg-gray-100 px-3 py-1 rounded-full text-sm" data-id="element-195">
                    {item.price}
                  </span>
                </div>)}
            </div>
          </div>

          {/* Piece Services Table */}
          <div className="bg-white rounded-2xl shadow-xl border border-gray-100 overflow-hidden" data-id="element-196">
            <div className="bg-red-600 px-6 py-4" data-id="element-197">
              <h3 className="text-xl font-bold text-white" data-id="element-198">
                Pintado por Piezas
              </h3>
            </div>
            <div className="divide-y divide-gray-100" data-id="element-199">
              {pieceServices.map((item, index) => <div key={index} className="flex items-center justify-between px-6 py-3 hover:bg-gray-50 transition-colors" data-id="element-200">
                  <div className="flex items-center" data-id="element-201">
                    <ChevronRightIcon className="h-4 w-4 text-red-500 mr-2" data-id="element-202" />
                    <span className="text-gray-800 font-medium" data-id="element-203">
                      {item.name}
                    </span>
                  </div>
                  <span className="text-gray-900 font-bold bg-red-50 px-3 py-1 rounded-full text-sm text-red-700" data-id="element-204">
                    {item.price}
                  </span>
                </div>)}
            </div>
          </div>
        </div>

        <div className="mt-12 text-center" data-id="element-205">
          <p className="text-sm text-gray-500 mb-8 italic" data-id="element-206">
            * Los precios son orientativos y pueden variar según el modelo del
            vehículo y el estado de la carrocería. Solicita tu presupuesto
            personalizado sin compromiso.
          </p>
          <a href="#contacto" className="inline-flex items-center justify-center rounded-md bg-red-600 px-8 py-4 text-base font-bold text-white shadow-lg hover:bg-red-700 transition-all hover:scale-105 glow-red" data-id="element-207">
            Solicitar presupuesto exacto
          </a>
        </div>
      </div>
    </section>;
}